<template>
	<div>
		<el-row>
			<el-col :span="22"><el-divider content-position="left"><h2>{{tital}}</h2></el-divider></el-col>
			<el-col :span="2"><span class="isShowBut" @click="isShowFun">{{isShow ? '收起': '展开'}}</span></el-col>
		</el-row>
		<div v-show="isShow" class="detailCon">
			<slot name="content"></slot>
		</div>
	</div>
</template>
<script>
export default {
	name: 'JsCollapse',
	props: {
		defaultShow: {
			type: Boolean,
			default: true
		},
		tital: {
			type: String,
			default: null
		}
	},
	data () {
		return {
			isShow: true
		}
	},
	watch: {
		defaultShow (val) {
			this.isShow = val
		}
	},
	methods: {
		isShowFun (val) {
			this.isShow = !this.isShow
		}
	}
}
</script>
<style lang="scss" scoped>
.isShowBut {
	line-height: 49px;
	// padding-left: -30px;
	color: #3C78FF;
	cursor: pointer;
	float: right;
}
.detailCon {
  line-height: 36px;
  font-size: 16px;
  color: rgb(92, 92, 92)
}
/deep/ .el-divider--horizontal{
 margin: 24px 30px;
}
.isShowBut {
  margin-right: 15px;
  float: right;
}
/deep/ .el-divider__text.is-left{
  left: -25px;
}
</style>



// WEBPACK FOOTER //
// src/js_components/js_collapse.vue